module.exports = __webpack_public_path__ + "static/media/up-arrow.088b4f55.svg";